import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

/**
 * Définir la distance
 */
export class SetDistanceCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private distance?: number,
  ) { }

  execute() {
    this.gamePlay.distance = this.distance

    console.log('COMMAND SetDistanceCommand', this.distance)
  }
}
